import { render } from "./footer.vue?vue&type=template&id=6c4d8baa"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c4d8baa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c4d8baa', __exports__)) {
    api.reload('6c4d8baa', __exports__)
  }
  
  module.hot.accept("./footer.vue?vue&type=template&id=6c4d8baa", () => {
    api.rerender('6c4d8baa', render)
  })

}


export default __exports__